import { ILS_MAIN_API_DATE_TIME_FORMAT, TimeStamp } from '@common/types';
import { isNil, isNumber } from 'lodash';
import moment from 'moment';

export const parseDateFromServerToUnix = (date?: string | null | TimeStamp): TimeStamp | undefined => {
  if (isNil(date)) return undefined;
  return isNumber(date) ? date : moment.utc(date, ILS_MAIN_API_DATE_TIME_FORMAT).unix();
};
